import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { atom, useAtom } from "jotai";
import { addNewInquiry } from "../../api/api";

const endUserAtom = atom();
const hwNumAtom = atom();
const osVerAtom = atom();
const dialogValueAtom = atom();
const modalInfoAtom = atom();
const osInfoAtom = atom();
const hwInfo1Atom = atom();
const hwInfo2Atom = atom();
const swInfoAtom = atom();
const titleAtom = atom();
const questionAtom = atom();
const mainMailAtom = atom();
const emailListAtom = atom();
const hWListAtom = atom([]);
const softwareNumAtom = atom();
const operationTypeAtom = atom(
    {
        1: "提案・導入前",
        2: "導入・構築",
        3: "運用中"
    }
);
const reapearanceAtom = atom(
    {
        1: "稀に",
        2: "頻繁",
        3: "必ず",
        4: "未選択"
    }
);
const attachedFileAtom = atom(
    {
        0: "なし",
        1: "あり"
    }
)


function MainComponent({ handleLoading }) {

    document.title = "新規お問い合わせ（確認用）| ファーストコンタクトセンター";
    const location = useLocation();
    const navigate = useNavigate();
    const [endUser, setEndUser] = useAtom(endUserAtom);
    const [hwNum, setHwNum] = useAtom(hwNumAtom);
    const [osVer, setOsVer] = useAtom(osVerAtom);
    const [dialogValue, setDialogValue] = useAtom(dialogValueAtom);
    const [modalInfo, setModalInfo] = useAtom(modalInfoAtom);
    const [osInfo, setOsInfo] = useAtom(osInfoAtom);
    const [hwInfo1, setHwInfo1] = useAtom(hwInfo1Atom);
    const [hwInfo2, setHwInfo2] = useAtom(hwInfo2Atom);
    const [swInfo, setSwInfo] = useAtom(swInfoAtom);
    const [operationType] = useAtom(operationTypeAtom);
    const [title, setTitle] = useAtom(titleAtom);
    const [question, setQuestion] = useAtom(questionAtom);
    const [reapearance] = useAtom(reapearanceAtom);
    const [attachedFile] = useAtom(attachedFileAtom);
    const [mainMail, setMainMail] = useAtom(mainMailAtom);
    const [emailList, setEmailList] = useAtom(emailListAtom);
    const [hWList, setHWList] = useAtom(hWListAtom);
    const [softwareNum, setSoftwareNum] = useAtom(softwareNumAtom);
    const insideCheck = ["", undefined, null, false, "[]"];
    setEndUser(location.state.endUser);
    setHwNum(location.state.hwNum);
    setOsVer(location.state.osVer);
    setDialogValue(location.state.dialogValue);
    setTitle(location.state.title);
    setQuestion(location.state.question);
    setMainMail(location.state.mainMail);
    setEmailList(location.state.emailList);
    setHWList(location.state.hWList);
    setSoftwareNum(location.state.softwareNum);
    if (dialogValue != null) {
        for (let i in dialogValue) {
            if (dialogValue[i].dialogId === "hwNameText0") {
                setModalInfo(dialogValue[i].value);
            }
            if (dialogValue[i].dialogId === "swNameText0") {
                setOsInfo(dialogValue[i].value);
            }
            if (dialogValue[i].dialogId === "hwNameText1") {
                setHwInfo1(dialogValue[i].value);
            }
            if (dialogValue[i].dialogId === "hwNameText2") {
                setHwInfo2(dialogValue[i].value);
            }
            if (dialogValue[i].dialogId === "swNameText1") {
                setSwInfo(dialogValue[i].value);
            }
        }

    }

    function initInput() {
        setEndUser("");
        setHwNum("");
        setOsVer("");
        setDialogValue("");
        setModalInfo("");
        setOsInfo("");
        setHwInfo1("");
        setHwInfo2("");
        setSwInfo("");
        setTitle("");
        setQuestion("");
        setMainMail("");
        setEmailList("");
        setHWList("");
        setSoftwareNum("");
    }

    const checkNumberList = (id) => {
        if (hWList) {
            if (insideCheck.includes(JSON.stringify(hWList)) !== true) {
                if (insideCheck.includes(hWList.find((val) => val.size === id)) !== true) {
                    if (insideCheck.includes(hWList.find((val) => val.size === id).num) !== true) {
                        return false
                    }
                    return true
                }
                return true
            }
            return true
        }
        return true
    }

    const collectEmails = () => {
        let sizeOfEmailList = Object.keys(emailList).length;
        let collectedEmails = mainMail;
        for (let i = 1; i <= sizeOfEmailList; i++) {
            let oneEmail = emailList.find((item) =>
                item.size === i);
            collectedEmails = collectedEmails + "," + oneEmail.email;
        }
        return collectedEmails;
    }

    const confirm = async () => {
        let operationType = parseInt(location.state.operationType)
        let attachedFile = parseInt(location.state.attachedFile)
        let reapearance = location.state.reapearance !== "4" ? location.state.reapearance : "";
        let hwNum1;
        let hwNum2;
        if (checkNumberList(1) === false) {
            hWList.map((val) => val.size === 1 ? hwNum1 = val.num : "")
        }
        if (checkNumberList(2) === false) {
            hWList.map((val) => val.size === 2 ? hwNum2 = val.num : "")
        }
        let relatedSoftwareModelNumber = softwareNum ? softwareNum.toString() : "";
        let collectedEmails = collectEmails();
        handleLoading(true);
        try {
            let data = await addNewInquiry(
                modalInfo,
                osInfo,
                hwInfo1,
                hwInfo2,
                swInfo,
                title,
                question,
                collectedEmails,
                operationType,
                attachedFile,
                endUser,
                hwNum,
                osVer,
                hwNum1,
                hwNum2,
                relatedSoftwareModelNumber,
                reapearance);
            if (data === false) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。尚、特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合にもエラーとなる可能性がございます。詳細は前ページの「お問い合わせ内容」の説明をご覧ください。");
                throw new Error("追加失敗");
            }
            const caseId = data.acceptanceNumber; //資料登録の caseIDに紐づく
            const contactId = data.contactId;
            var next_state = {
                userName: "",
                companyName: "",
                divisionName: "",
                secretInfo: "",
                personalInfo: "",
                caseId: caseId,
                contactId: contactId
            };
            handleLoading(false);
            initInput();
            if (parseInt(location.state.attachedFile) === 1) {
                navigate("/file_info_edit", {
                    state: {
                        next_state: next_state,
                        page: true
                    }
                })

            }
            if (parseInt(location.state.attachedFile) === 0) {
                navigate("/inquiry_completion", { state: { page: true } })
            }
        } catch (e) {
            // TODO エラー表示
            ;
        } finally {
            handleLoading(false);
        }
    };
    const goBack = () => {

        navigate("/inquiry_create", {
            state: {
                endUser: location.state.endUser,
                hwNum: location.state.hwNum,
                osVer: location.state.osVer,
                operationType: location.state.operationType,
                reapearance: location.state.reapearance,
                title: location.state.title,
                question: location.state.question,
                attachedFile: location.state.attachedFile,
                dialogValue: location.state.dialogValue,
                emailList: location.state.emailList,
                mainMail: location.state.mainMail,
                emailSize: location.state.emailSize,
                softwareNum: location.state.softwareNum,
                hWList: location.state.hWList,
                hWSize: location.state.hWSize,
                sWList: location.state.sWList,
                sWSize: location.state.sWSize,
                page: true
            }
        });
        initInput();
    }
    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>新規お問い合わせ(確認用)</span>
                    </h2>
                    <div className="mod-tbl-form">
                        <div style={{ marginBottom: "15px" }}>
                            <div> お問い合わせ内容を下記に表示していますので、内容を確認の上、確認ボタンを押してください。</div>
                            <div> 添付資料「あり」の場合は、確認ボタン押下後、資料登録する画面が表示されます。</div>
                            <div> 管理情報を入力した後、添付ファイル アップロード画面で添付資料のアップロードを行ってください。</div>
                        </div>
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お客様名(エンドユーザ様名)</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="end_user">{(endUser !== undefined) && (endUser !== "") ? endUser : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">本体(モデル名)</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="model_name">
                                            {modalInfo}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">本体型番</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="model_number">{(hwNum !== undefined) && (hwNum !== "") ? hwNum : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">OS名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="os_name">
                                            {osInfo}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">OSバージョン</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="os_version">{(osVer !== undefined) && (osVer !== "") ? osVer : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">運用形態</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="operation_form">{operationType[location.state.operationType]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">再現性・発生頻度</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="reapearance">{location.state.reapearance !== ("" || "4") ? reapearance[location.state.reapearance] : "（未選択）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            {(hwInfo1 !== undefined) && (hwInfo1 !== "") && (hwInfo1 !== null) ? <tbody id="hardware_name1_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">関連ハードウェア名1</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="hardware_name1">
                                            {hwInfo1}
                                        </div>
                                    </td>
                                </tr>
                            </tbody> : null}

                            {(hwInfo1 !== undefined) && (hwInfo1 !== "") && (hwInfo1 !== null) ? <tbody id="hardware_model1_body" >
                                <tr >
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">関連ハードウェア型番1</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="hardware_model1">{checkNumberList(1) === false && hWList.map((val) => val.size === 1) ? hWList[0].num : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody> : null}
                            {(hwInfo2 !== undefined) && (hwInfo2 !== "") && (hwInfo2 !== null) ? <tbody id="hardware_name2_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">関連ハードウェア名2</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="hardware_name2">
                                            {hwInfo2}
                                        </div>
                                    </td>
                                </tr>
                            </tbody> : null}

                            {(hwInfo2 !== undefined) && (hwInfo2 !== "") && (hwInfo2 !== null) ? <tbody id="hardware_model2_body" >
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">関連ハードウェア型番2</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="hardware_model2">{checkNumberList(2) === false && hWList.map((val) => val.size === 2) ? hWList[1].num : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody> : null}

                            {(swInfo !== undefined) && (swInfo !== "") && (swInfo !== null) ? <tbody id="software_name_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">関連ソフトウェア名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="software_name">
                                            {swInfo}
                                        </div>
                                    </td>
                                </tr>
                            </tbody> : null}

                            {(swInfo !== undefined) && (swInfo !== "") && (swInfo !== null) ? <tbody id="software_model_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">関連ソフトウェア型番</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="software_model">{softwareNum ? softwareNum : "（未入力）"}
                                        </div>
                                    </td>
                                </tr>
                            </tbody> : null}

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">件名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="title">{title}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ内容</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="question" className="text-pre-wrap">{question}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">添付ファイル有無</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="attached_file">{attachedFile[location.state.attachedFile]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>マイナンバー（個人番号）の確認</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input">
                                            お問い合わせ内容および添付資料にマイナンバーは含まれません。
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">回答送付先1</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="mail">{mainMail}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            {emailList ? emailList.map((val, index) =>
                                (val !== undefined) && (val.email !== "") ? (
                                    <tbody key={index + "key"}>
                                        <tr key={index + "key2"}>
                                            <td className="caption" key={index + "key3"}>
                                                <div className="inner" key={index + "key4"}>
                                                    <b key={index + "key5"}><span id={"mail" + val.size} htmlFor="section" key={index + "key6"}>回答送付先{val.size + 1}</span></b>
                                                </div>
                                            </td>
                                            <td key={index + "key7"}>
                                                <div id="mail" key={index + "key8"}>{val.email}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>) : null) : null}
                        </table>
                    </div>
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left"
                                onClick={goBack}>戻る</button>
                        </div>
                        <div className="btn">
                            <button id="btn-send" className="btn_default_select" onClick={confirm}>確認</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MainComponent;